import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import FireIcon from '~/icons/components/FireIcon';
import { ProductTag } from '~/shared/constants/products';
import { desktop, mobile } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import theme from '../../../styles/themes/fabletics/theme';

const HotCommentWrapper = styled.div`
  display: flex;
  ${desktop`
  	padding: 10px 0;
  	padding-left: 16px;
  	margin-bottom: 32px;
	`}
  ${mobile`
		padding: 10px 32px;
		padding-bottom: unset;
		margin-bottom: 8px;
		justify-content: center;
		align-items: center;
	`}
`;

const HotCommentBody = styled.div`
  display: inline-block;
`;

function HotComment({ product }) {
  const { tagIdList } = product;
  let commentBody = null;
  if (tagIdList.includes(ProductTag.lastChance)) {
    commentBody = (
      <HotCommentBody>
        <b>
          <FormattedMessage
            id="site_pdp.hot_comment_last_chance_header"
            defaultMessage="Last Chance to Buy:"
          />
        </b>
        &nbsp;
        <FormattedMessage
          id="site_pdp.hot_comment_last_chance_body"
          defaultMessage="this color/print is not coming back!"
        />
      </HotCommentBody>
    );
  }

  if (commentBody) {
    return (
      <HotCommentWrapper>
        <FireIcon
          size={21}
          color={theme.colors.alertRed}
          style={{ marginRight: '9px' }}
        />
        {commentBody}
      </HotCommentWrapper>
    );
  } else {
    return null;
  }
}

HotComment.propTypes = {
  product: PropTypes.object,
};

export default HotComment;
